export default "__VITE_PUBLIC_ASSET__1437d841__"